const encodeTargets = (targets) => {
  return encodeURIComponent(
    Object.keys(targets)
      .map((target) => `${target}=${targets[target]}`)
      .join('&'),
  )
}

export default encodeTargets
